type RecentProjectSegment = {
  id: string;
  name: string;
};

const ELLIPSIS_SEGMENT: RecentProjectSegment = { id: 'ELLIPSIS', name: '...' };

export function getProjectHierarchyDisplaySegements(
  segments: RecentProjectSegment[],
  { maxWidthPx, pxPerChar }: { maxWidthPx: number; pxPerChar: number }
): RecentProjectSegment[] {
  if (segments.length <= 2) {
    return segments;
  }

  const separatorCharCount = 1;
  const availableChars = Math.floor(maxWidthPx / pxPerChar);

  const fullNamesChars = segments.reduce((sum, s) => sum + s.name.length, 0);
  const fullPathChars = fullNamesChars + (segments.length - 1) * separatorCharCount;
  if (fullPathChars <= availableChars) {
    return segments;
  }

  const [rootProject, ...rest] = segments;
  const projectName = rest[rest.length - 1];
  const subProjects = rest.slice(0, -1);

  const ellipsisChars = ELLIPSIS_SEGMENT.name.length;
  const leafChars = projectName.name.length;

  const reservedChars = ellipsisChars + leafChars + 2 * separatorCharCount;
  const budgetForPrefix = availableChars - reservedChars;

  let accumulatedChars = rootProject.name.length + separatorCharCount;
  let displayableCount = 0;

  for (let subProjectIndex = 0; subProjectIndex < subProjects.length; subProjectIndex++) {
    const nextSegmentChars = subProjects[subProjectIndex].name.length + separatorCharCount;

    if (accumulatedChars + nextSegmentChars > budgetForPrefix) {
      break;
    }

    accumulatedChars += nextSegmentChars;
    displayableCount = subProjectIndex + 1;
  }

  const displayableSubProjects = subProjects.slice(0, displayableCount);

  return [rootProject, ...displayableSubProjects, ELLIPSIS_SEGMENT, projectName];
}
